// extracted by mini-css-extract-plugin
export default {"tabs":"index_tabs__mdIpb","tab":"index_tab__LA0PP","active":"index_active__xaPxX","line":"index_line__ZBztX","mini":"index_mini__aikcb"};